import * as React from "react"
const SvgSettingsTune = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 9.857a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h2v-3q0-.424.288-.712A.97.97 0 0 1 17 3.857q.424 0 .712.288a.97.97 0 0 1 .288.712v3h2q.424 0 .712.288.288.287.288.712c0 .425-.096.521-.288.713a.97.97 0 0 1-.712.287zm3 12a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-8q0-.424.288-.712a.97.97 0 0 1 .712-.288q.424 0 .712.288a.97.97 0 0 1 .288.712v8a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287m-10 0a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-3H4a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713q0-.424.288-.712A.97.97 0 0 1 4 15.857h6a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287H8v3a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287m0-8a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 7 3.857a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v8a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287" />
  </svg>
)
export default SvgSettingsTune
